// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_mQB_u {
  width: 480px;
  height: 100%;
}

.pad_KtoRR {
  padding: var(--size-padLarge, 10px);
}

.header_hRUrS {
  position: relative;
}

.contentArea_muecb {
  background: #f3f5f6;
}

.close_OGbd2 {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.successImage__iU15 {
  margin: 20px auto;
  display: block;
}

.buttonContainer_NaNzq {
  width: 100%;
  background-color: white;
  border-radius: 6px;
  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
  padding: 0 10px;
}

.buttonContainer_NaNzq > * {
  border-bottom: 1px solid var(--color-base200) !important;
}

.buttonContainer_NaNzq > *:last-child {
  border-bottom: none !important;
}

.buttonWrap_afxxm {
  display: inline-block;
}

.unpairOption_jYDBV {
  border : 1px solid var( --color-base200 );
  background-color: var( --color-white );
  padding : var( --size-padMedium );
  border-radius : var( --size-padSmall );
}

.unpairOption_jYDBV > .unpairOption_jYDBV {
  border : unset;
  background-color: unset;
  padding: unset;
  border-radius: unset;
}

.activeUnpairOption_ssxov {
  border : 1px solid var( --color-brand200 );
  background-color: var( --color-brand025 );
  padding : var( --size-padMedium );
  border-radius : var( --size-padSmall );
}

.activeUnpairOption_ssxov > .activeUnpairOption_ssxov {
  border : unset;
  background-color: unset;
  padding: unset;
  border-radius: unset;
}

.divider_YqO0q {
  width: 100%;
  height: 0px;
  border: 1px solid var( --color-base200 );
}

.container_FI46s {
  background: #FFFFFF;
  border: 1px solid var( --color-base100 );
  border-radius: 8px;
  padding: 12px;
}

.nameValueContainer_ddLdP {
  flex: 1 !important;
  overflow: hidden !important;
}

.body_iQuyd {
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  line-height: 24px !important;
  color: var( --color-base700 ) !important;
}

.name_3cwDI {
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  line-height: 24px !important;
  color: var( --color-base700 ) !important;
}

.value_ulvUO {
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 24px !important;
  color: var( --color-base800 ) !important;
}

.form_vwVGW {
  min-height: 400px;
  padding: var(--size-padXLarge) !important;
  display: flex;
  flex-direction: column;
  gap: var(--size-padMedium);
}

.dialog_yn2Yb {
  width: 400px;
}

.headerIcon_QCsEm {
  width: 24px;
  height: 24px;
}

.disabled_DOfhT {
  color : gray;
  opacity: 0.5;
  pointer-events: none;
}

@media only screen and (max-width: 1023px) {
  .form_vwVGW {
    width: 100%;
    max-height: 80vh;
  }

  .dialog_yn2Yb {
    margin: 0 var(--size-pad12);
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/pairKeys/PairKeysToVehicle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".content {\n  width: 480px;\n  height: 100%;\n}\n\n.pad {\n  padding: var(--size-padLarge, 10px);\n}\n\n.header {\n  position: relative;\n}\n\n.contentArea {\n  background: #f3f5f6;\n}\n\n.close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.successImage {\n  margin: 20px auto;\n  display: block;\n}\n\n.buttonContainer {\n  width: 100%;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n  padding: 0 10px;\n}\n\n.buttonContainer > * {\n  border-bottom: 1px solid var(--color-base200) !important;\n}\n\n.buttonContainer > *:last-child {\n  border-bottom: none !important;\n}\n\n.buttonWrap {\n  display: inline-block;\n}\n\n.unpairOption {\n  border : 1px solid var( --color-base200 );\n  background-color: var( --color-white );\n  padding : var( --size-padMedium );\n  border-radius : var( --size-padSmall );\n}\n\n.unpairOption > .unpairOption {\n  border : unset;\n  background-color: unset;\n  padding: unset;\n  border-radius: unset;\n}\n\n.activeUnpairOption {\n  border : 1px solid var( --color-brand200 );\n  background-color: var( --color-brand025 );\n  padding : var( --size-padMedium );\n  border-radius : var( --size-padSmall );\n}\n\n.activeUnpairOption > .activeUnpairOption {\n  border : unset;\n  background-color: unset;\n  padding: unset;\n  border-radius: unset;\n}\n\n.divider {\n  width: 100%;\n  height: 0px;\n  border: 1px solid var( --color-base200 );\n}\n\n.container {\n  background: #FFFFFF;\n  border: 1px solid var( --color-base100 );\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.nameValueContainer {\n  flex: 1 !important;\n  overflow: hidden !important;\n}\n\n.body {\n  font-style: normal !important;\n  font-weight: 400 !important;\n  font-size: 15px !important;\n  line-height: 24px !important;\n  color: var( --color-base700 ) !important;\n}\n\n.name {\n  font-style: normal !important;\n  font-weight: 400 !important;\n  font-size: 15px !important;\n  line-height: 24px !important;\n  color: var( --color-base700 ) !important;\n}\n\n.value {\n  font-style: normal !important;\n  font-weight: 600 !important;\n  font-size: 15px !important;\n  line-height: 24px !important;\n  color: var( --color-base800 ) !important;\n}\n\n.form {\n  min-height: 400px;\n  padding: var(--size-padXLarge) !important;\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-padMedium);\n}\n\n.dialog {\n  width: 400px;\n}\n\n.headerIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.disabled {\n  color : gray;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n@media only screen and (max-width: 1023px) {\n  .form {\n    width: 100%;\n    max-height: 80vh;\n  }\n\n  .dialog {\n    margin: 0 var(--size-pad12);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_mQB_u`,
	"pad": `pad_KtoRR`,
	"header": `header_hRUrS`,
	"contentArea": `contentArea_muecb`,
	"close": `close_OGbd2`,
	"successImage": `successImage__iU15`,
	"buttonContainer": `buttonContainer_NaNzq`,
	"buttonWrap": `buttonWrap_afxxm`,
	"unpairOption": `unpairOption_jYDBV`,
	"activeUnpairOption": `activeUnpairOption_ssxov`,
	"divider": `divider_YqO0q`,
	"container": `container_FI46s`,
	"nameValueContainer": `nameValueContainer_ddLdP`,
	"body": `body_iQuyd`,
	"name": `name_3cwDI`,
	"value": `value_ulvUO`,
	"form": `form_vwVGW`,
	"dialog": `dialog_yn2Yb`,
	"headerIcon": `headerIcon_QCsEm`,
	"disabled": `disabled_DOfhT`
};
export default ___CSS_LOADER_EXPORT___;
